import { PreviewAssetSourceResponseSchema, AssetCategoryListResponseSchema, AssetDepreciationScheduleResponseSchema, AssetListResponseSchema, AssetSchema, AssetDisposalPreviewResponseSchema, AssetDisposalCalculationResponseSchema, AssetDisposalReadResponseSchema, AssetDisposalStateSchema, CreateAssetCategoryResponseSchema, CreateAssetResponseSchema, PreviewAssetRegistrationResponseSchema, DepreciationRunPlanSchema, DepreciationRunResultSchema, PreviewAssetAccountsResponseSchema, } from '@packages/types';
import { api } from '../client.js';
function pageQuery(params) {
    const query = new URLSearchParams();
    if (params?.cursor)
        query.set('cursor', params.cursor);
    if (params?.limit !== undefined)
        query.set('limit', String(params.limit));
    const value = query.toString();
    return value ? `?${value}` : '';
}
export function listAssetCategories(accountId, ledgerId, params) {
    return api(`/accounts/${accountId}/ledgers/${ledgerId}/asset-categories${pageQuery(params)}`, AssetCategoryListResponseSchema);
}
export function createAssetCategory(accountId, ledgerId, input) {
    return api(`/accounts/${accountId}/ledgers/${ledgerId}/asset-categories`, CreateAssetCategoryResponseSchema, { method: 'POST', body: input });
}
export function listAssets(accountId, ledgerId, params) {
    return api(`/accounts/${accountId}/ledgers/${ledgerId}/assets${pageQuery(params)}`, AssetListResponseSchema);
}
export function getAsset(accountId, ledgerId, assetId) {
    return api(`/accounts/${accountId}/ledgers/${ledgerId}/assets/${assetId}`, AssetSchema);
}
export function createAsset(accountId, ledgerId, input) {
    return api(`/accounts/${accountId}/ledgers/${ledgerId}/assets`, CreateAssetResponseSchema, { method: 'POST', body: input });
}
export function previewAssetRegistration(accountId, ledgerId, input) {
    return api(`/accounts/${accountId}/ledgers/${ledgerId}/assets/registration-preview`, PreviewAssetRegistrationResponseSchema, { method: 'POST', body: input });
}
export function previewAssetAccounts(accountId, ledgerId, input) {
    return api(`/accounts/${accountId}/ledgers/${ledgerId}/assets/account-preview`, PreviewAssetAccountsResponseSchema, { method: 'POST', body: input });
}
export function getAssetDepreciationSchedule(accountId, ledgerId, assetId) {
    return api(`/accounts/${accountId}/ledgers/${ledgerId}/assets/${assetId}/depreciation-schedule`, AssetDepreciationScheduleResponseSchema);
}
export function previewDepreciationRun(accountId, ledgerId, throughDate) {
    return api(`/accounts/${accountId}/ledgers/${ledgerId}/assets/depreciation-run/preview?throughDate=${encodeURIComponent(throughDate)}`, DepreciationRunPlanSchema);
}
export function runDepreciation(accountId, ledgerId, input) {
    return api(`/accounts/${accountId}/ledgers/${ledgerId}/assets/depreciation-run`, DepreciationRunResultSchema, { method: 'POST', body: input });
}
export function calculateAssetDisposal(accountId, ledgerId, assetId, input) {
    return api(`/accounts/${accountId}/ledgers/${ledgerId}/assets/${assetId}/disposal/calculation`, AssetDisposalCalculationResponseSchema, {
        method: 'POST', body: input,
    });
}
export function previewAssetDisposal(accountId, ledgerId, assetId, input) {
    return api(`/accounts/${accountId}/ledgers/${ledgerId}/assets/${assetId}/disposal/preview`, AssetDisposalPreviewResponseSchema, {
        method: 'POST', body: input,
    });
}
export function confirmAssetDisposal(accountId, ledgerId, assetId, input) {
    return api(`/accounts/${accountId}/ledgers/${ledgerId}/assets/${assetId}/disposal`, AssetDisposalStateSchema, {
        method: 'POST', body: input,
    });
}
export function getAssetDisposal(accountId, ledgerId, assetId) {
    return api(`/accounts/${accountId}/ledgers/${ledgerId}/assets/${assetId}/disposal`, AssetDisposalReadResponseSchema);
}
export function previewAssetSource(accountId, ledgerId, input) {
    return api(`/accounts/${accountId}/ledgers/${ledgerId}/assets/source-preview`, PreviewAssetSourceResponseSchema, { method: 'POST', body: input });
}
export function getAssetBySourceSupplierInvoice(accountId, ledgerId, supplierInvoiceId) {
    return api(`/accounts/${accountId}/ledgers/${ledgerId}/assets/by-source-invoice/${supplierInvoiceId}`, AssetSchema.nullable());
}
